import type { MetacategoryData, MetacategoryOptionsMap } from '@openx/types/targeting/metacategory';

export function prepareMetacategoryOptions(apiOptionsMap: MetacategoryOptionsMap): MetacategoryOptionsMap {
  return Object.values(apiOptionsMap)
    .filter(metacategory => metacategory.metacategory_code.toLocaleLowerCase() !== 'mfa')
    .map(metacategory => ({ [metacategory.metacategory_code]: metacategory }))
    .reduce((acc, curr) => Object.assign(acc, curr), {});
}

export const clearMetacategoryCategories = (
  emptyMappedTargetingParams: MetacategoryData,
  params: MetacategoryData
): MetacategoryData => {
  return {
    ...emptyMappedTargetingParams,
    exclude_mfa: params.exclude_mfa,
    keywords: params.keywords,
  };
};

export const clearMetacategoryKeywords = (mappedTargetingParams: MetacategoryData): MetacategoryData => {
  return {
    ...mappedTargetingParams,
    keywords: { includes: [], excludes: [] },
  };
};
